export enum PageNames {
    Splash = "splash",
    DashBoard = "dashboard",

    //Apps
    App_Operations = "operations",
    App_Marketing = "marketing",
    App_BrewMenu = "brew-menu",
    App_BrewKnowledge = "brew-knowledge",
    App_MediaLibrary = "media-library",

    Error = "error",
    Search = "search",
    Alerts = "alerts",

    //Authentication
    Login = "login",
    SignUp = "sign-up",
    RequestAccount = "request-account",
    ForgotPassword = "forgot-password",
    MagicLink = "magic",

    //Account
    Account = "account",
    Profile = "profile",
    Security = "security",
    Preferences = "preferences",
    Messages = "messages",
    BrewKnowledge = "brew-knowledge",

    //Operations
    PPUnsubscribed = "unsubscribed",
    OnTap = "on-tap",
    OnDeck = "on-deck",
    EditKeg = "edit-keg",
    ReceiveKeg = "receive-keg",
    ResolveKeg = "resolve-keg",

    //Catalog
    Inventory = "inventory",
    Products = "products",
    AddProduct = "add-product",

    //Management
    Branding = "branding",
    Locations = "locations",
    AddLocation = "add-location",
    MediaLibrary = "media-library",
    Events = "events",
    Upload = "upload",

    //Analytics
    Analytics = "analytics",
    BrewStats = "brew-stats",

    //Analytics PP
    Throughput = "throughput",
    LevelAnalysis = "level-analysis",
    DepletionAnalysis = "depletion-analysis",
    KickDateAnalysis = "kick-date-analysis",
    FreshnessAnalysis = "freshness-analysis",
    StylesOnTap = "styles-on-tap",
    History = "history",

    //Analytics MMB
    ProductStyles = "product-styles",
    Favorites = "favorites",
    Impressions = "impressions",
    SavedRoutes = "saved-routes",

    // BrewMenu
    BMA_Unsubscribed = "unsubscribed",
    BrewMenu = "brew-menu",
    Menus = "menus",
    Displays = "displays",
    BrewMenuSettings = "settings",
    BMA_Overview = "overview",
    BMA_Pricing = "bma-pricing",
    BMA_Discounts = "bma-discounts",
    EditDisplay = "edit-display",
    AddMenu = "add-menu",
    EditMenu = "edit-menu",

    //PP Settings
    LocationDetails = "location-details",
    WorkWeekAndHours = "work-week-and-hours",
    Pricing = "pricing",
    PriorityBrands = "priority-brands",
    DraftProgram = "draft-program",
    BatteryReplacement = "battery-replacement",
    MMB_Settings = "settings",
    PP_Settings = "settings",
    BrandingDetails = "branding-details",

    //Org
    OrgSettings = "org-settings",
    Teams = "teams",
    TeamManagement = "team-management",
    Billing = "billing"
}
